<div style="padding:24px 32px 0">
    <app-file-system-base-info
        [item]="data"
    ></app-file-system-base-info>
    <app-base-performace-chart [id]="data.actionParams" [performance]="[523,511,182]" type="FILE_SYSTEM"></app-base-performace-chart>
    <app-file-system-resource [fileId]="data.actionParams"></app-file-system-resource>
</div>
